var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResourceDetail',{attrs:{"store-override":"rancher","resource-override":"token","parent-route-override":"account"}})
}
var staticRenderFns = []

export { render, staticRenderFns }